import React from "react";
import VinSearch from "components/VinSearch/VinSearch";
import { VinSearchCtxProvider } from "components/VinSearch/VinSearchContext";
import { DecoratedVinSearch } from "@carfax/web-ui/components/DecoratedVinSearch";
import { useTranslations } from "next-intl";

interface VinSearchSectionProps {
  headerText?: string;
  withShadow?: boolean;
  className?: string;
}

const VinSearchSection: React.FC<VinSearchSectionProps> = ({ headerText, withShadow, className }) => {
  const t = useTranslations("page-account-reports");

  const decoratedVinSearchProps = {
    headerText: headerText || t("sectionVinSearch.title"),
    withShadow: withShadow,
    className: className,
  };

  return (
    <section data-testid="account-reports-vin-search">
      <VinSearchCtxProvider>
        <DecoratedVinSearch {...decoratedVinSearchProps}>
          <VinSearch />
        </DecoratedVinSearch>
      </VinSearchCtxProvider>
    </section>
  );
};

export default VinSearchSection;
